// extracted by mini-css-extract-plugin
export default {"form":"Search_form__jUSwi","input":"Search_input__klILD","btn":"Search_btn__uMWgM"};